<template>
  <div class="section__container">
    <div class="container">
      <div class="row">
        <div class="col">
          <p class="title">{{ title }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <p class="description" v-html="descriptionContent">
          </p>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col">
          <p class="title">{{imgTitle  }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <img :src="imgMarket">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import imgTest from '@/assets/profile/Group.png'
import { getPropertyMarket } from "@/services/property";

export default {
  name: 'FinancialsTab',
  data () {
    return { 
      imgTest:imgTest,
      imgMarket:'',
      descriptionContent: '',
      title: '',
      imgTitle: ''
    }
  },
  props: {
    property: {
      type: Object,
      required: true
    }
  },
  created () {
    this.getPropertyMarket(this.property.attributes.property_market.data.id)
    console.log('ESto paso en la property MARKET', this.property.attributes.property_market.data)
  },
  methods: {
    getContent(content) {
      var MarkdownIt = require('markdown-it'),
      md = new MarkdownIt();
      var result = md.render(content);
      return result
    },
    getPropertyMarket(id) {
      getPropertyMarket(id).then((response) => { 
        console.log("response Property", response.data.data[0].attributes)
        
        if (response.data.data[0].attributes.Image.data) {
          this.imgMarket = response.data.data[0].attributes.Image.data.attributes.url
        }
        
        this.descriptionContent = this.getContent(response.data.data[0].attributes.Detail)
        this.title = response.data.data[0].attributes.Title
        this.imgTitle = response.data.data[0].attributes.ImageTitle
      })

    },
  }
}
</script>
<style lang="scss">
.section__container {
  display: flex;
  flex-direction: column;
  gap: 44px;
}
p.description p {
  font-weight: unset !important;
}
.description {
  font-family: Roboto;
  font-size: 16px;
  font-weight: unset;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
  color:#000;
}

.title {
  //styleName: Montserrat Semibold/H3MSB24;
  font-family: Montserrat;
  font-size: 24px;
  font-weight: 600;
  line-height: 30px;
  letter-spacing: 0em;
  text-align: left;
  color: #351467;

}

.table__container {
  display: flex;
  flex-direction: column;
  gap: 36px;
}

.title__background {
  margin: 16px 0;
  padding: 14px 16px;
  background-color: #CAEEDD;
  font-weight: 600;
  color: #351467;
}
</style>